import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import IconChevronRight from '@bubble-ui/icon-chevron-right';
import IconChevronLeft from '@bubble-ui/icon-chevron-left';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useTokenDeprecationWarning from '@bubble-ui/hook-use-token-deprecation-warning';
import TouchableIcon from '@bubble-ui/molecule-touchable-icon';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var DatePickerMonthComponent = _ref => {
  var {
    backLabel,
    description,
    disabled,
    forwardLabel,
    id,
    inline,
    label,
    onGoToNextMonth,
    onGoToPreviousMonth,
    warning
  } = _ref;
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var {
    headerContainerStyle,
    iconBackWrapperStyle,
    iconForwardWrapperStyle,
    inlineIconBackWrapperStyle,
    inlineIconForwardWrapperStyle,
    inlineModeWrapperStyle,
    descriptionTextStyle,
    rootStyle,
    titlePrimarySmallStyle,
    titleSecondaryStyle
  } = getDefaultStyleSheet({
    description,
    designContext,
    disabled,
    inline,
    warning
  });
  var deprecateTextColorTokenExists = designContext.hasTokenInContext('date-picker/text-color');
  useTokenDeprecationWarning({
    componentName: 'DatePicker',
    tokenName: 'date-picker/text-color',
    useInstead: "date-picker/day-text-color', 'date-picker/month-text-color' and 'date-picker/weekday-text-color",
    shouldWarn: deprecateTextColorTokenExists,
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: rootStyle
  }, inline ? /*#__PURE__*/React.createElement(View, {
    style: inlineModeWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: inlineIconBackWrapperStyle
  }, onGoToPreviousMonth ? /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.backIcon,
    ariaLabel: backLabel,
    Icon: IconChevronLeft,
    onPress: onGoToPreviousMonth
  }) : undefined), /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.label,
    numberOfLines: 0,
    style: titlePrimarySmallStyle
  }, label), /*#__PURE__*/React.createElement(View, {
    style: inlineIconForwardWrapperStyle
  }, onGoToNextMonth ? /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.forwardIcon,
    ariaLabel: forwardLabel,
    Icon: IconChevronRight,
    onPress: onGoToNextMonth
  }) : undefined)) : /*#__PURE__*/React.createElement(View, {
    style: headerContainerStyle
  }, /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.label,
    numberOfLines: 0,
    style: titleSecondaryStyle
  }, label), onGoToPreviousMonth ? /*#__PURE__*/React.createElement(View, {
    style: iconBackWrapperStyle
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.backIcon,
    ariaLabel: backLabel,
    Icon: IconChevronLeft,
    onPress: onGoToPreviousMonth
  })) : undefined, onGoToNextMonth ? /*#__PURE__*/React.createElement(View, {
    style: iconForwardWrapperStyle
  }, /*#__PURE__*/React.createElement(TouchableIcon, {
    id: ids === null || ids === void 0 ? void 0 : ids.forwardIcon,
    ariaLabel: forwardLabel,
    Icon: IconChevronRight,
    onPress: onGoToNextMonth
  })) : undefined), description && /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 0,
    style: descriptionTextStyle,
    tag: "paragraph"
  }, description));
};
DatePickerMonthComponent.displayName = 'DatePickerMonth';
export var DatePickerMonth = withProvisionalOverrideFromContext(DatePickerMonthComponent);
//# sourceMappingURL=index.js.map